import HttpService from './http';

export default class ConnectionHttpService {
  static join = async event_uid => {
    const url = `/v2.0/connections/${event_uid}/join`;
    return await HttpService.get(url, true);
  };
}
